const validatePhone = phone => phone && phone.match(/(0047|\+47|47)?\d{8}/)

export default validatePhone
